import React from "react";
import ModalPopup from "../../../components/newcomponents/ModalPopup";
import { logout } from "../../../Apimanager/Networking";
export const InactivityModal = ({
   title = "Session Expiring",
   subtitle = "You’ve been inactive for almost 10 minutes. Do you want to continue your session?",
   onCancel = () => {},
}) => {
   const endSession = () => {
      logout();
   };
   return (
      <ModalPopup onModalTapped={() => {}}>
         <div className="main-container-epic-delete">
            <div className="title-header-epic-delete">{title}</div>
            <div className="label-subtitle-epic-delete">{subtitle}</div>
            <div className="buttons-containers-epic-delete">
               <button onClick={endSession} className="button-epic-cancel">
                  End Session
               </button>
               <button onClick={onCancel} className="button-epic-delete">
                  {"Continue Session"}
               </button>
            </div>
         </div>
      </ModalPopup>
   );
};
